import axios from 'axios';
import Encryption from './payload-encryption';
import {
  addToFailedQueue,
  getIsRefreshing,
  setIsRefreshing,
  triggerSessionDialog,
} from '../components/Common/RefreshDialog/SessionDialougeTrigger';

const encryption = new Encryption();

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// 🔹 Request Interceptor (Encrypt Payload Automatically)
instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('accessToken');

    if (config.requiresAuth && token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    if (config.data && !(config.data instanceof FormData)) {
      config.data = {
        encData: encryption.encrypt(JSON.stringify(config.data)),
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
instance.interceptors.response.use(
  (response) => {
    if (response.data?.encData) {
      try {
        const decrypted = encryption.decrypt(response.data.encData);
        return JSON.parse(decrypted);
      } catch (err) {
        console.error('Decryption error', err);
      }
    }
    return response;
  },
  (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      return new Promise((resolve, reject) => {
        addToFailedQueue({
          resolve: (token) => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(instance(originalRequest));
          },
          reject: (err) => {
            reject(err);
          },
        });

        if (!getIsRefreshing()) {
          setIsRefreshing(true);
          triggerSessionDialog();
        }
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
